import apiClientService from "../api/ApiClientService";

// GET /calendar            — calendarul unei perioade (vezi backend src/calendar/calendar.types.ts)
// GET /calendar/free-slots — locurile libere pentru „Caută loc liber”
// POST /calendar/lessons, /calendar/lessons/:id/move — Paste (lecție nouă / mutare), verificat pe server

async function readOrThrow(res, fallback) {
   if (res.ok) return res.json();
   let msg = fallback;
   let code = "";
   try {
      const err = await res.json();
      if (err?.message) msg = Array.isArray(err.message) ? err.message.join(" ") : err.message;
      code = String(err?.code || "");
   } catch {}
   const error = new Error(msg);
   error.status = res.status;
   error.code = code;
   throw error;
}

function query(params) {
   const p = new URLSearchParams();
   for (const [key, value] of Object.entries(params || {})) {
      if (value === undefined || value === null || value === "") continue;
      p.set(key, Array.isArray(value) ? value.join(",") : String(value));
   }
   const qs = p.toString();
   return qs ? `?${qs}` : "";
}

export async function fetchCalendar(params) {
   return readOrThrow(await apiClientService.get(`/calendar${query(params)}`), "Nu am putut încărca calendarul.");
}

/** Cine are acces la calendar (panoul „Oameni” → „Acces”), doar personalul. */
export async function fetchCalendarAccess() {
   return readOrThrow(await apiClientService.get("/calendar/access"), "Nu am putut încărca lista de acces.");
}

export async function fetchFreeSlots(params) {
   return readOrThrow(
      await apiClientService.get(`/calendar/free-slots${query(params)}`),
      "Nu am putut căuta locurile libere.",
   );
}

/** Lecție nouă pe o celulă: { userId, instructorId, date, time, sector?, gearbox?, … unblock? } → { reservation, unblockedBlockIds }. */
export async function createCalendarLesson(body) {
   return readOrThrow(await apiClientService.post("/calendar/lessons", JSON.stringify(body)), "Programarea nu a putut fi creată.");
}

/** Notița pe o celulă, fără blocare: { instructorId, date, time, text } (text gol = șterge) → { note }. */
export async function saveCalendarSlotNote(body) {
   return readOrThrow(await apiClientService.put("/calendar/slot-notes", JSON.stringify(body)), "Notița nu s-a salvat.");
}

/**
 * Mută aceeași lecție: { instructorId, date, time, sector?, gearbox?, unblock? } sau, la anulare,
 * { instructorId, exactStartTime, sector, gearbox, isCancelled } → { reservation, moved, previous, unblockedBlockIds }.
 */
export async function moveCalendarLesson(id, body) {
   return readOrThrow(
      await apiClientService.post(`/calendar/lessons/${encodeURIComponent(id)}/move`, JSON.stringify(body)),
      "Lecția nu a putut fi mutată.",
   );
}

// --- graficul instructorilor (ecranul „Grafic instructori” și „Programul zilei” din calendar) ---

/** Versiunile graficului și excepțiile pe zile: { today, range, schedules: [{ instructorId, current, versions }], exceptions }. */
export async function fetchInstructorSchedules(params) {
   return readOrThrow(await apiClientService.get(`/instructor-schedules${query(params)}`), "Nu am putut încărca graficul.");
}

/** Versiunea valabilă de la `validFrom`: { days: 7 × "07:00-18:00" | null, note? } → { version }. */
export async function saveScheduleVersion(instructorId, validFrom, body) {
   return readOrThrow(
      await apiClientService.put(
         `/instructor-schedules/${encodeURIComponent(instructorId)}/versions/${encodeURIComponent(validFrom)}`,
         JSON.stringify(body),
      ),
      "Graficul nu s-a salvat.",
   );
}

export async function deleteScheduleVersion(instructorId, validFrom) {
   return readOrThrow(
      await apiClientService.delete(`/instructor-schedules/${encodeURIComponent(instructorId)}/versions/${encodeURIComponent(validFrom)}`),
      "Versiunea nu s-a șters.",
   );
}

/** O zi altfel: { hours: "10:00-13:30" | null (nu lucrează), reason? } → { exception }. */
export async function saveDayException(instructorId, date, body) {
   return readOrThrow(
      await apiClientService.put(
         `/instructor-schedules/${encodeURIComponent(instructorId)}/exceptions/${encodeURIComponent(date)}`,
         JSON.stringify(body),
      ),
      "Programul zilei nu s-a salvat.",
   );
}

/** Ziua revine la grafic. */
export async function deleteDayException(instructorId, date) {
   return readOrThrow(
      await apiClientService.delete(`/instructor-schedules/${encodeURIComponent(instructorId)}/exceptions/${encodeURIComponent(date)}`),
      "Programul zilei nu s-a salvat.",
   );
}
